(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["store-selector-check-modal"] && !Shopify.designMode) return;
  try {
    const el = document.querySelector('[data-js="store-selector-check-modal"]');

  if (!el) {
    return;
  }

  const updateStoreButton = el.querySelector('[data-js="store-selector-check-modal__update"]');
  const closeButtonModal = el.querySelector('[data-js="modal__close"]');
  const closeButton = document.querySelector('[data-js="store-selector-check-modal__close"]');
  const currentStoreLabel = el.querySelector('[data-js="current_store"]');
  const targetStoreLabel = el.querySelector('[data-js="target_store"]');
  const countrySelect = el.querySelector('[data-js="custom-select__country"]');
  const languageSelect = el.querySelector('[data-js="custom-select__language"]');
  const locale = document.documentElement.lang || undefined;
  const ENABLE_DEBUG_MODAL_HOTKEY = false;

  const storeSelectorCountryOptions = Array.from(
    document.querySelectorAll('[data-js="store-selector-select-country"] option[data-code]')
  );
  const storeSelectorLanguageOptions = Array.from(
    document.querySelectorAll('[data-js="store-selector-select-lang"] option[data-locale]')
  );

  const languageLabelByCode = storeSelectorLanguageOptions.reduce((acc, option) => {
    const code = (option.dataset.locale || option.value || '').toUpperCase();

    if (code) {
      acc[code] = (option.textContent || '').trim() || code;
    }

    return acc;
  }, {});

  const stores = storeSelectorCountryOptions
    .map((option) => ({
      code: (option.dataset.code || option.value || '').toUpperCase(),
      name: (option.textContent || '').trim(),
      href: option.dataset.href || '',
      altHref: option.dataset.althref || '',
      defaultLocale: (option.dataset.defaultlocale || '').toUpperCase(),
      locales: (option.dataset.locales || '')
        .split(',')
        .map((value) => value.trim().toUpperCase())
        .filter(Boolean),
    }))
    .filter((store) => store.code && store.href)
    .sort((a, b) => a.name.localeCompare(b.name, locale, { sensitivity: 'base' }));

  const storesByCode = stores.reduce((acc, store) => {
    acc[store.code] = store;
    return acc;
  }, {});

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
  }

  function getCookie(name) {
    return document.cookie
      .split('; ')
      .find((row) => row.startsWith(name + '='))
      ?.split('=')[1];
  }

  function buildStoreUrl(baseUrl, selectedLocale, countryCode) {
    const language = (selectedLocale || 'EN').toLowerCase();
    const supportedLanguages = ['en', 'it', 'fr', 'de', 'es'];
    let path = window.location.pathname;

    path = path.replace(new RegExp(`^/(${supportedLanguages.join('|')})(/|$)`, 'i'), '/');

    const normalizedCountryCode = (countryCode || '').toUpperCase();
    const languageMap = {
      DK: { en: 'en-US', dk: 'da-DK' },
      SE: { en: 'en-US', se: 'sv-SE' },
    };
    const mappedLocale = languageMap[normalizedCountryCode]?.[language];
    const localizedPath = ['en', 'dk', 'se'].includes(language) ? path : `/${language}${path}`;
    const normalizedPath = localizedPath.replace(/\/+/g, '/');
    const targetUrl = new URL(normalizedPath, `${baseUrl}/`);

    if (mappedLocale) {
      targetUrl.searchParams.set('gl_language', mappedLocale);
    }

    if (normalizedCountryCode) {
      targetUrl.searchParams.set('country', normalizedCountryCode);
    }

    return targetUrl.toString();
  }

  function populateCountrySelect(selectedCode) {
    countrySelect.innerHTML = stores
      .map(
        (store) =>
          `<option value="${store.code}"${store.code === selectedCode ? ' selected' : ''}>${store.name}</option>`
      )
      .join('');
  }

  function populateLanguageSelect(countryCode, selectedLocale) {
    const store = storesByCode[countryCode];
    const locales = store?.locales?.length ? store.locales : ['EN'];
    const defaultLocale = store?.defaultLocale || locales[0] || 'EN';
    const finalLocale = locales.includes((selectedLocale || '').toUpperCase())
      ? selectedLocale.toUpperCase()
      : defaultLocale;

    languageSelect.innerHTML = locales
      .map((lang) => {
        const label = languageLabelByCode[lang] || lang;
        return `<option value="${lang}"${lang === finalLocale ? ' selected' : ''}>${label}</option>`;
      })
      .join('');

    languageSelect.disabled = locales.length <= 1;
    languageSelect.value = finalLocale;
  }

  function updateStorePreferencesLink() {
    const countryCode = (countrySelect.value || '').toUpperCase();
    const localeCode = (languageSelect.value || '').toUpperCase();
    const store = storesByCode[countryCode];

    if (!store) {
      updateStoreButton.href = '#';
      targetStoreLabel.dataset.href = '';
      targetStoreLabel.disabled = true;
      return;
    }

    const defaultLocale = (store.defaultLocale || '').toUpperCase();
    const shouldUseMainHref = !store.altHref || localeCode === defaultLocale;
    const baseUrl = shouldUseMainHref ? store.href : store.altHref;

    const targetUrl = buildStoreUrl(baseUrl, localeCode, countryCode);

    updateStoreButton.href = targetUrl;
    targetStoreLabel.dataset.href = targetUrl;
    targetStoreLabel.disabled = false;
  }

  function syncModalSelectors(countryCode, selectedLocale) {
    const fallbackCountry = (el.dataset.current_store || '').toUpperCase();
    const finalCountry = storesByCode[countryCode] ? countryCode : fallbackCountry;

    populateCountrySelect(finalCountry);
    populateLanguageSelect(finalCountry, selectedLocale);
    updateStorePreferencesLink();
  }

  countrySelect.addEventListener('change', () => {
    const selectedCountry = (countrySelect.value || '').toUpperCase();
    populateLanguageSelect(selectedCountry);
    updateStorePreferencesLink();
  });

  languageSelect.addEventListener('change', () => {
    updateStorePreferencesLink();
  });

  targetStoreLabel.addEventListener('click', () => {
    const targetUrl = targetStoreLabel.dataset.href;

    if (!targetUrl || targetUrl === '#') {
      return;
    }

    window.location.href = targetUrl;
  });

  closeButtonModal.addEventListener('click', () => {
    el.close();
  });

  closeButton?.addEventListener('click', () => {
    el.close();
  });

  if (ENABLE_DEBUG_MODAL_HOTKEY) {
    let debugTyped = '';
    document.addEventListener('keydown', (event) => {
      if (event.ctrlKey || event.metaKey || event.altKey) return;
      const key = (event.key || '').toLowerCase();
      if (!/^[a-z]$/.test(key)) return;

      debugTyped = (debugTyped + key).slice(-5);
      if (debugTyped === 'debug') {
        syncModalSelectors((el.dataset.current_store || '').toUpperCase());
        el.showModal();
        debugTyped = '';
      }
    });
  }

  if (!getCookie('user_country')) {
    geoip2.country(
      function success(location) {
        const currentCountry = (el.dataset.current_store || '').toUpperCase();
        const countryCode = (location.country.iso_code || '').toUpperCase();
        const ipCountry = storesByCode[countryCode];

        currentStoreLabel.innerHTML = currentStoreLabel.innerHTML.replace(
          '%redirect_store_name%',
          ipCountry?.name || countryCode
        );
        targetStoreLabel.innerHTML = targetStoreLabel.innerHTML.replace(
          '%redirect_store_name%',
          ipCountry?.name || countryCode
        );
        setCookie('user_country', countryCode, 7);

        syncModalSelectors(countryCode);

        if (currentCountry !== countryCode) {
          el.showModal();
        }
      },
      function error(err) {
        console.warn('GeoIP lookup failed:', err);
        syncModalSelectors((el.dataset.current_store || '').toUpperCase());
      }
    );
  } else {
    syncModalSelectors((getCookie('user_country') || el.dataset.current_store || '').toUpperCase());
  }
  } catch(e) { console.error(e); }
})();

})();
